import { cn } from "@/lib/utils";
import { HardDrive } from "lucide-react";

export function LocalBanner({ className, text }) {
  return (
    <div
      className={cn(
        "flex items-start gap-2.5 rounded-md border border-amber-300 bg-amber-50 px-3.5 py-2.5 text-sm text-amber-800",
        className
      )}
      data-testid="local-only-banner"
    >
      <HardDrive className="h-4 w-4 mt-0.5 shrink-0" />
      <span>
        {text || (
          <>
            <b>Saved on this device.</b> Your live backend has no endpoint for this yet, so changes
            stay in this browser and don't sync to the mobile app.
          </>
        )}
      </span>
    </div>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display font-black text-3xl leading-none">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1.5">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
